<div class="container-fluid"  *ngIf="chTheme1">
    <app-header-ch1 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings"
        [custom_ticker]="custom_ticker" [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist"
        [isSticky]="isSticky" [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader"
        [showLogo]="showLogo" [showCart]="showCart">
    </app-header-ch1>
</div>
<div *ngIf="chTheme2">
    <app-header-ch2 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart" [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch2>
</div>

<div class="container-fluid p-md-0" *ngIf="chTheme3">
    <app-header-ch3 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart"  [isSearchByVehicleDisabled]="isSearchByVehicleDisabled" >
    </app-header-ch3>
</div>
<div class="container-fluid bg-black"  *ngIf="chTheme4">
    <app-header-ch4 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader"  [showThirdRowHeader]="showThirdRowHeader" [showLogo]="showLogo"
        [showCart]="showCart"  [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch4>
</div>
<div class="container-fluid" *ngIf="chTheme5">
    <app-header-ch5 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showThirdRowHeader]="showThirdRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart">
    </app-header-ch5>
</div>

<div  *ngIf="chTheme6">
    <app-header-ch6 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart">
    </app-header-ch6>
</div>

<div class="container-fluid" *ngIf="chTheme7">
    <app-header-ch7 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart" [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch7>
</div>

<div class="p-md-0" *ngIf="chTheme9">
    <app-header-ch9 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showThirdRowHeader]="showThirdRowHeader" [showLogo]="showLogo"
        [showCart]="showCart"  [isSearchByVehicleDisabled]="isSearchByVehicleDisabled" >
    </app-header-ch9>
</div>


<div  *ngIf="chTheme8">
    <app-header-ch8 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showThirdRowHeader]="showThirdRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart" [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch8>
</div>

<div class="container-fluid" *ngIf="chTheme10">
    <app-header-ch10 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showThirdRowHeader]="showThirdRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart" [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch10>
</div>
<div class="container-fluid" *ngIf="chTheme11">
    <app-header-ch11 (scrollToTop)="scrollTop()" [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showThirdRowHeader]="showThirdRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart">
    </app-header-ch11>
</div>
<div class="header-cust-container" *ngIf="chTheme12">
    <app-header-ch12  [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart" [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch12>
</div>
<div class="container-fluid" *ngIf="chTheme13 || chTheme15">
    <app-header-ch13  [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart" [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch13>
</div>
<div *ngIf="chTheme14">
    <app-header-ch14  [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"
        [isMobile]="isMobile" [headerdata]="headerdata" [isWishlist]="isWishlist" [isSticky]="isSticky"
        [showSecondRowHeader]="showSecondRowHeader" [showFirstRowHeader]="showFirstRowHeader" [showLogo]="showLogo"
        [showCart]="showCart" [isSearchByVehicleDisabled]="isSearchByVehicleDisabled">
    </app-header-ch14>
</div>